import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService, UserService } from '@app/services';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    private userService: UserService
  ) {
  }

  async canActivate(): Promise<boolean> {
    const session = await this.authService.getSession();
    if (!session) {
      await this.router.navigate(['/login']);
      return false;
    }

    let status: Awaited<ReturnType<UserService['getConfirmationStatus']>>;
    try {
      status = await this.userService.getConfirmationStatus();
    } catch (error) {
      console.error('檢查使用者驗證狀態失敗:', error);
      status = 'unknown';
    }

    // 網路中斷或 token 換新中無法確認時保留登入，由 app 的離線畫面處理，
    // 只有確定已失去登入或未通過審核才登出。
    if (status === 'confirmed' || status === 'unknown') {
      return true;
    }

    await this.authService.signOut();
    await this.router.navigate(['/login']);
    return false;
  }
}
